import script from "./HowItWorks.vue?vue&type=script&setup=true&lang=ts"
export * from "./HowItWorks.vue?vue&type=script&setup=true&lang=ts"

import "./HowItWorks.vue?vue&type=style&index=0&id=521fc2fa&scope=true&lang=scss"

const __exports__ = script;

export default __exports__